// src/components/Navbar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import profileImg from "../assets/images/etc/YahavCorcos_CoverPhoto.jpg";

const linkBase =
  "relative px-3 py-2 text-sm font-medium tracking-wide uppercase transition";
const linkActive = "text-white";
const linkIdle = "text-text/80 hover:text-white";

export default function Navbar({ isAdmin = false, setIsAdmin }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-bg/60 bg-bg/80 border-b border-white/5">
      <nav className="mx-auto max-w-6xl px-4">
        <div className="h-16 flex items-center justify-between">
          <NavLink to="/" className="flex items-center gap-2">
            <img
              src={profileImg}
              alt="Yahav Corcos"
              className="h-8 w-8 rounded-full object-cover ring-1 ring-brand/30"
            />
            <span className="font-display text-lg font-semibold">Yahav</span>
          </NavLink>

          <button
            className="md:hidden p-2 rounded-lg hover:bg-white/5 focus:outline-none focus-visible:shadow-glow"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
          >
            <svg width="24" height="24" fill="none" stroke="currentColor">
              <path strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <div className="hidden md:flex items-center gap-1">
            {["/home", "/about", "/experience", "/projects", "/contact"].map(
              (to, i) => {
                const label = [
                  "Home",
                  "About",
                  "Experience",
                  "Projects",
                  "Contact",
                ][i];
                return (
                  <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) =>
                      `${linkBase} ${isActive ? linkActive : linkIdle}`
                    }
                  >
                    {label}
                    <span className="absolute inset-x-2 -bottom-1 h-px scale-x-0 group-hover:scale-x-100 transition-transform origin-left bg-brand/60" />
                  </NavLink>
                );
              }
            )}
            {isAdmin && (
              <NavLink
                to="/settings"
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : linkIdle}`
                }
              >
                Settings
              </NavLink>
            )}
            {isAdmin && (
              <button
                onClick={() => setIsAdmin?.(false)}
                className="ml-2 text-rose-400 hover:text-rose-300 text-sm"
              >
                Logout
              </button>
            )}
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-2 space-y-1">
            {[
              { to: "/home", label: "Home" },
              { to: "/about", label: "About" },
              { to: "/experience", label: "Experience" },
              { to: "/projects", label: "Projects" },
              { to: "/contact", label: "Contact" },
            ].map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block rounded-lg px-3 py-2 ${
                    isActive
                      ? "bg-white/5 text-white"
                      : "text-text/80 hover:bg-white/5 hover:text-white"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}
